import { FunctionComponent } from 'preact';
import { useDetectDevice } from 'hooks';
import { PudoLocation } from '@pperform/pp-data-mappers';
import { useTranslation } from 'react-i18next';
import { ButtonContainer, Button, CardPanel } from './DropOffCard.styles';
import {
  DropOffCarrier,
  DropOffNumber,
  DropOffOpeningHours,
} from './components';
import { DropOffAddress } from './components/DropOffAddress';
import { buildOperatingHoursByService } from './services';

export interface DropOffCardPanelProps {
  dropOff: PudoLocation;
  onSelectDropOff?: (dropOff: PudoLocation) => void;
  isShowDropoffMap?: boolean;
  isViewOnly?: boolean;
}

const DropOffCardPanel: FunctionComponent<DropOffCardPanelProps> = ({
  dropOff,
  onSelectDropOff,
  isViewOnly = true, // Default to true as panel content is typically view-only
}): JSX.Element => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  const { operatingHoursCalc, carrier } = dropOff;
  const { phone } = dropOff.address;
  const { lat, lng } = dropOff;

  const operatingHours = buildOperatingHoursByService(operatingHoursCalc);
  const isOperatingHoursAvailable = operatingHours?.length !== 0;
  const isCarrierNotEmpty =
    carrier &&
    Object.keys(carrier).length !== 0 &&
    Object.values(carrier).every((value) => value);

  return (
    <div>
      <CardPanel>
        {!isViewOnly && (
          <DropOffAddress
            address={dropOff.address}
            coordinates={{ lat, lng }}
            variant="link"
            displayText={t('VIEW_ON_MAP')}
          />
        )}
        {isOperatingHoursAvailable && (
          <DropOffOpeningHours operatingHours={operatingHours} />
        )}
        {phone && <DropOffNumber phoneNumber={phone} />}
        {isCarrierNotEmpty && (
          <DropOffCarrier
            carrierId={carrier.carrierId}
            carrierName={carrier.name}
          />
        )}
      </CardPanel>
      {!isViewOnly && onSelectDropOff && (
        <ButtonContainer>
          <Button
            onClick={(event) => {
              event.stopPropagation();
              onSelectDropOff(dropOff);
            }}
            isMobile={isMobile}
          >
            {t('RETURN_SELECT_DROPOFF_CTA')}
          </Button>
        </ButtonContainer>
      )}
    </div>
  );
};

export { DropOffCardPanel };
